import React from "react";

export const EmptyState = ({
  title = 'No data available',
  description = 'Try adjusting your filters or check back later.',
  icon: Icon = null,
  action = null
}) => {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center">
      {Icon && (
        <Icon size={48} className="text-white/20 mb-4" />
      )}
      <h3 className="text-lg font-bold text-white/80 mb-2">{title}</h3>
      <p className="text-white/50 text-sm max-w-md">{description}</p>
      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
};
